import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';
import Text14 from '@sdk/components/ui/typography/Text14';
import Picker from '@sdk/components/forms/Picker';
import gettext from '@sdk/lang/gettext';
import useAuth from '@sdk/authentication/useAuth';
import { BreakCategory } from '@sdk/settings/types';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { useUserOrgSettings } from '@web/settings/UserOrgSettingsContext';
import {
  BREAK_CATEGORY_OPTIONS,
  BREAK_DURATION_OPTIONS,
} from '@web/settings/components/schedule/Breaks/breaks.consts';
import { FIELD_WIDTH_205 } from '@web/settings/constants';

const StandardBreaksContent = () => {
  const { currentUser } = useAuth();
  const { userOrgSettings, onUserOrgSettingsChange } = useUserOrgSettings();
  return (
    <>
      <Row alignItems="center" justifyContent="space-between" mTop={20}>
        <Column>
          <Text14 semiBold themeColor={ThemeColorType.gray}>
            {gettext('Break category')}
          </Text14>
          <Text14 themeColor={ThemeColorType.gray}>
            {gettext('Specify whether breaks are paid or unpaid.')}
          </Text14>
        </Column>

        <Picker
          disabled={!currentUser.isAdmin}
          options={BREAK_CATEGORY_OPTIONS}
          value={userOrgSettings.shiftBreakType}
          customWidth={FIELD_WIDTH_205}
          onChange={(shiftBreakType: BreakCategory): void => {
            onUserOrgSettingsChange({ shiftBreakType });
          }}
        />
      </Row>

      <Row alignItems="center" justifyContent="space-between" mTop={20} mBottom={20}>
        <Column>
          <Text14 semiBold themeColor={ThemeColorType.gray}>
            {gettext('Default break duration')}
          </Text14>
          <Text14 themeColor={ThemeColorType.gray}>
            {gettext('Set the break duration that will populate for new shifts.')}
          </Text14>
        </Column>

        <Picker
          disabled={!currentUser.isAdmin}
          options={BREAK_DURATION_OPTIONS}
          value={userOrgSettings.shiftBreakDefaultDuration}
          customWidth={FIELD_WIDTH_205}
          onChange={(shiftBreakDefaultDuration: number): void => {
            onUserOrgSettingsChange({ shiftBreakDefaultDuration });
          }}
        />
      </Row>
    </>
  );
};

export default StandardBreaksContent;
